export default function({ host, path }, { apiUrl, bookingApiUrl }) {
  let hostUrl
  switch (host) {
    case "main":
      hostUrl = apiUrl
      break
    case "booking":
      hostUrl = bookingApiUrl
      break
    default:
      hostUrl = host
  }
  return path ? `${hostUrl}/${path}` : hostUrl
}
